
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";
import {
  GET_COMPANY_DETAILS,
  GET_USER_DETAILS
} from "@/store/modules/auth/constants";
import {
  APP_ASSESSMENT_RESULT,
  APP_ASSESSMENTS
} from "@/store/modules/common/constants";
import { REDO_ASSESSMENT_REQUEST } from "@/store/modules/recruiter/constants";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

export type AssessmentCardType = {
  status: string | null;
  is_show: boolean;
  type: string;
  title?: string;
  description?: string;
  icon?: string;
  version?: string;
};
export default Vue.extend({
  name: "DashboardAssessmentCard",
  props: {
    assessment: {
      type: Object as () => AssessmentCardType,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters("common", {
      app_assessments: APP_ASSESSMENTS
    }),
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    }),
    ...mapGetters("auth", {
      get_company_details: GET_COMPANY_DETAILS
    })
  },
  methods: {
    ...mapActions("recruiter", {
      redo_assessment_request: REDO_ASSESSMENT_REQUEST
    }),
    ...mapActions("common", {
      app_assessment_result: APP_ASSESSMENT_RESULT
    }),
    async do_assessment() {
      if (this.$props.assessment.type === "ai") {
        this.$router.push("/candidate/ai-assessments");
        return;
      }
      this.loading = true;

      if (this.$props.assessment.status === "CANCELLED") {
        const assessment = this.app_assessments.find(
          (val: AppAssessments.Assessment) =>
            val.assessment_type === this.$props.assessment.version
        );
        await this.redo_assessment_request(assessment.id);
        this.$emit("update:assessment_status", "REDO");
        this.$emit("update:is_show_assessment", false);
      } else {
        const navigation_map: Record<string, string> = {
          english: "/candidate/assessments/english",
          annotation: "/candidate/assessments/annotation"
        };
        this.$router.push(
          navigation_map[this.$props.assessment.type as string]
        );
      }
      this.loading = false;
    },
    async get_assessment() {
      if (this.$props.assessment.type === "ai") {
        return;
      }
      let eng_version =
        this.get_company_details?.storage_path?.assessment_setting
          ?.candidates_english;
      let ann_version =
        this.get_company_details?.storage_path?.assessment_setting
          ?.candidates_annotation;

      const findVersion =
        this.$props.assessment.type === "english" ? eng_version : ann_version;
      const assessment = this.app_assessments.find(
        (val: AppAssessments.Assessment) => val.assessment_type === findVersion
      );
      // Check if english assessment is attempted or not

      if (assessment) {
        const assessmentResultExist = await this.app_assessment_result({
          assessment_id: assessment.id
        });
        if (assessmentResultExist) {
          this.$emit("update:assessment_status", assessmentResultExist.status);
          if (
            assessmentResultExist.status ===
            AppAssessments.AppAssessmentStatus.CANCELLED
          ) {
            this.$emit("update:is_show_assessment", true);
          } else {
            this.$emit("update:is_show_assessment", false);
          }
        }
      }
    }
  },
  async mounted() {
    this.loading = true;
    await this.get_assessment();
    this.loading = false;
  }
});
